
<div *ngIf="movements && entity.type === 'COMPANY'" class="panel">
  <h2 *ngIf="mode === 'default'">Liste des mouvements</h2>
  <h2 *ngIf="mode === 'deleted'">Liste des mouvements supprimés</h2>
  <h2 *ngIf="mode === 'draft'">Liste des mouvements en attente de validation</h2>

  <div class="btn-toolbar" *ngIf="canAdd">

    <a class="btn btn-small btn-gray" [routerLink]="['movements', 'new']" title="Ajouter un nouveau mouvement">
      <t-icon name="add"></t-icon>
      <span class="text">Ajouter</span>
    </a>

  </div>

  <table *ngIf="movements.length > 0">
    <thead>
      <tr>
        <th *ngIf="mode === 'default'" style="width: 10px;">N°</th>
        <th style="width: 110px;">Date</th>
        <th>Description</th>
        <th style="width: 50px;"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let movement of movements; index as index" (click)="showMovement(movement)">
        <td *ngIf="mode === 'default'" style="width: 10px;" name="N°">{{ index + 1 }}</td>
        <td style="width: 110px;" name="Date">{{ movement.writingDate | movementwritingdate }}</td>
        <td name="Description">{{ movement.description }}</td>
        <td style="width: 50px;" class="actions">
          <a class="action-btn">
            <t-icon name="arrow_forward"></t-icon>
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="empty-table compact" *ngIf="movements.length === 0">
    <p>Aucun mouvement enregistré pour cette entité</p>
  </div>

</div>